export class AllPatient {
  org_code: string;
  user_id: number;
  first_name: string;
  last_name: string;
  dob: string;
  gender: string;
  address_1: string;
  address_2: string;
  city_n: string;
  state: string;
  zip: number;
  contact_no: number;
  email: string;
  height: string;
  weight: number;
  bp_level: string;
  med_condition: [];
  diagnosis_d: [];
  symptoms: string;
  allergy: string;
  current_med: string;
  med_intake: string;
  consulting_phy: string;
  patid: string;
  name: string;
  pid: number;
  ppurl: string;
  email_id: string;
  relation: string;
  universal_id: string;
  members: Array<any>;
  age: string;
  patient_status: boolean;
  patient_appetite_all: any;
  patient_lifestyle_all: any;
  patient_current_consultation: any;
  avatarimg: string;
  createdby: number;
  createdat: Date;
  updatedby: number;
  upadtedat: Date;
}
